module.exports = __webpack_public_path__ + "images/assets/c2fa9151a769967406238e453532a39e.svg";